import { render, staticRenderFns } from "./builder-generate-button.vue?vue&type=template&id=46fc254f&"
import script from "./builder-generate-button.vue?vue&type=script&lang=js&"
export * from "./builder-generate-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports